import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {environment as env} from '../../../environments/environment';
import { OrderonlineServiceService } from '../../services/orderonline-service.service';
import {LanguageService} from '../../services/language.service';
import { HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-wishlist',
  templateUrl: './wishlist.component.html',
  styleUrls: ['./wishlist.component.css']
})

export class WishlistComponent implements OnInit {
  imgurl:string;
  bnrAr:any[]=[];
  wishList = [];
  isLoading:boolean;
  showLang:string;

  constructor(private route:ActivatedRoute,private bnrObj:OrderonlineServiceService,
    private http:HttpClient,private langObj:LanguageService) { 
    this.imgurl =  env.imgurl;
    this.langObj.langStr.subscribe((data)=>{
      this.showLang = data;
    });
  } 

  ngOnInit(): void {

    this.showLang = localStorage.getItem("showLang");
    if(this.showLang == null && this.showLang == undefined){
     this.showLang = 'en';
    }

    this.bnrObj.orderOnlineBanner('Cart Page').subscribe((data:any)=>{
      this.bnrAr = data.data[0];
    });

    var uid = localStorage.getItem('sajid');
    if(uid !=null && uid != undefined){
      //get reward points
      this.http.get(env.apiurl+'wishlist-list?userid='+uid).subscribe(data=>{
        this.wishList  = data['data']['data'];
      });

    }
  }


  removeWishlist(pid){
    this.isLoading = true;
    var uid = localStorage.getItem('sajid');
    this.bnrObj.rmWishlist(pid, uid).subscribe((data:any)=>{
      this.isLoading = false;
        if(data['success']){
          location.reload();
        }
    });
  }


}
